import { FC } from 'react';
import { Drawer } from 'antd';

import { AttachmentDestination, CloudAttachment, CloudStorageConnection } from '@/services';

import AttachmentDocumentView from '../AttachmentDocumentView';
import AttachmentPreview from '../AttachmentPreview';

interface AttachmentDocumentDrawerProps {
    attachment?: CloudAttachment;
    canComment?: boolean;
    connection?: CloudStorageConnection;
    destination?: AttachmentDestination;
    error?: string;
    loading?: boolean;
    open: boolean;
    onAttachmentCreated?: (attachment: CloudAttachment) => void;
    onAttachmentsBreadcrumbNavigate?: () => void;
    onClose: () => void;
    onResourceBreadcrumbNavigate?: () => void;
    resourceBreadcrumbLabel?: string;
    resourceBreadcrumbPath?: string;
}

const AttachmentDocumentDrawer: FC<AttachmentDocumentDrawerProps> = ({ open, onClose, ...viewProps }) => {
    return (
        <Drawer
            closable={false}
            destroyOnHidden
            open={open}
            placement='right'
            width='min(72rem, 100%)'
            onClose={onClose}
            styles={{
                body: { minHeight: 0, overflow: 'hidden', padding: 0 },
            }}
        >
            <AttachmentDocumentView {...viewProps} onClose={onClose} />
        </Drawer>
    );
};

export { AttachmentPreview };
export default AttachmentDocumentDrawer;
